import { component_tool, utils_tool } from '../../../../tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import React from 'react'

//配置项
let componentName = 'seriesProgram'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课程名称",
    name: "programName",
    dataIndex: "programName",
    searchItem: {},
    tableItem: {},
  },
  {
    title: "分类",
    name: "categoryName",
    dataIndex: "categoryName",
    tableItem: {},
  },
  {
    title: "分类",
    name: "categoryId",
    dataIndex: "categoryId",
    searchItem: {
      type: 'treeselect',
      allowClear:true,
      dict: {
        wizReplaceData: "treeData",
        defalutType: []
      },
    }
  },
  {
    title: "关联时间",
    name: "relationTime",
    dataIndex: "relationTime",
    tableItem: {},
  },

  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
    },
  }


];

const templateConfig = (data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          // dataFormat: (params) => {
          //   let value = Object.assign({}, params)
          //   value.seriesId = data.id;
          //   return value
          // },
          buttonSort: ['add', "export"],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/series/seriesList/seriesContentList/seriesContentDetailAdd",
                  record: {seriesId:data.id ,categoryId:data.categoryId}
                }
              }

            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          //selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update', 'enableOrDisable'],
        rowOperateView: [

          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/series/seriesList/seriesContentList/seriesContentDetailUpd",
                record: {seriesId:data.id ,categoryId:data.categoryId}
              },
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "禁用/启用" },
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '禁用', 0: "启用" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                  }课程吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ...record,
                      state: record['state'] === 1 ? 0 : 1,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          }
        ],
        commonOperate: {}
      }
    }
  }
};


const apis = (treeDateId,seriesId) => {
  return (
    {
      list: {
        path: `${componentName}/listByPage`,
        payload: {
          key: `${componentName}@listByPage`,
          apiParams: {seriesId:seriesId }
        }
      },
      updateStatus: {
        path: `${componentName}/update`,
        payload: {
          key: `${componentName}@updateStatus`,
          apiParams: {}
        }
      },
      export: {
        path: `${componentName}/export`,
        payload: {
          key: `${componentName}@export`,
          apiParams: {seriesId:seriesId}
        }
      },
      treeData: {
        path: `questionType/normalNodeList`,
        payload: {
          key: `questionType@treeData`,
          apiParams: { type: 8, id: treeDateId,state:1 }
        }
      }
    }
  )
}


let reduxTemplateCofig = (args) => {
  const treeDateId = args.treeDateId;
  return {
    apis: apis(treeDateId,args.seriesId),
    componentName,
    initApiKeys: ['list', 'treeData'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
